export default __webpack_public_path__ + "static/media/history.2b50cd6e.svg";